import React from "react";
import styles from "./Pricing.module.css";
import NorthEastIcon from '@mui/icons-material/NorthEast';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useNavigate } from "react-router-dom";

function Pricing() {
    const navigate = useNavigate();

    return (
        <div className={styles["pricing-container"]} id="pricing">
            <div className={styles["pricing-content"]}>
                <div className={styles["pricing-heading"]}>
                    <div className={styles["pricing-emblem"]}>
                        <ShoppingCartIcon className={styles["cart-icon"]} />
                    </div>

                    <h2>Explore Our Current Plans</h2>

                </div>

                <div className={styles["price-cards"]}>

                <div className={styles["price-card"]}>
                    <h3>FREE</h3>
                    
                    <h4 className={styles["price-tag"]}>
                        <span>$</span>
                        0.00
                        <span>/mo</span>
                    </h4>

                    <p className={styles["price-desc"]}>
                        <span>100 processing credits per month</span> 
                    </p>

                    <button 
                        className={`${styles["btn-primary"]} ${styles["btn-width-full"]}`}
                        onClick={() => navigate("/auth/register")}
                    >
                        Register Now
                        <NorthEastIcon className={styles["btn-arrow"]}/>
                    </button>
                </div>
                <div className={styles["price-card"]}>
                    <h3>ESSENTIALS</h3>
                    
                    <h4 className={styles["price-tag"]}>
                        <span>$</span>
                        20.00
                        <span>/mo</span>
                    </h4>

                    <p className={styles["price-desc"]}>
                        <span>100 free processing credits per month + 3000 paid credits</span> + $0.007 per additional credit.
                    </p>

                    <button 
                        className={`${styles["btn-primary"]} ${styles["btn-width-full"]}`}
                        onClick={() => navigate("/auth/register")}
                    >
                        Register Now
                        <NorthEastIcon className={styles["btn-arrow"]}/>
                    </button>
                </div>
            </div>
                    <p className={styles["pricing-desc"]}>
                        Not seeing a plan that fits your needs? <a href="https://presagetechnologies.com/contact-us" target="__blank" rel="noopener noreferrer" className={styles["txt-link"]}>Contact us</a>, we'd be happy to help! 
                    </p>
            </div>
        </div>
    )
}

export default Pricing;
